import { render, staticRenderFns } from "./EnglishMenu.vue?vue&type=template&id=ccd4925e&scoped=true&"
import script from "./EnglishMenu.vue?vue&type=script&lang=js&"
export * from "./EnglishMenu.vue?vue&type=script&lang=js&"
import style0 from "./EnglishMenu.vue?vue&type=style&index=0&id=ccd4925e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccd4925e",
  null
  
)

export default component.exports